/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login/login";
import Dashboard from "./pages/Dashboard/dashboard";
import OrderManagement from "./pages/OrderManagement/order-management";
import OrderCreateOutlet from "./pages/OrderCreateOutlet";
import Location from "./pages/Location/location";
import Header from "./components/Header";
import { Toaster } from "react-hot-toast";
import { useEffect, useRef, useState } from "react";
import { useProfileData } from "./apis/profileApis";
import ForgotPassword from "./pages/Forgot-password/ForgotPassword";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import LineHaulManagement from "./pages/LineHaulManagement/line-haul-management";
import Settings from "./pages/Settings/settings";
import LoadingScreen from "./components/common/LoadingScreen";
import Profile from "./pages/Profile/profile";
import PickupManagement from "./pages/PickupManagement/pickup-management";
import InvoiceManagement from "./pages/InvoiceManagement/invoice-management";
import ZoneManagement from "./pages/ZoneManagement/zone-management";
import HelpandSupport from "./pages/HelpandSupport/help-and-support";
import ViewShipmentDetails from "./pages/PickupManagement/ViewShipmentDetails";
import { initSocket } from "./socket";
import InverntoryProduct from "./pages/InventoryManagement/inverntory-product";
import AddItem from "./pages/InventoryManagement/add-item";
import Notification from "./pages/Notification/notification";
import ViewOrderDetails from "./pages/OrderManagement/ViewOrderDetails";
import {
  addNewOrder,
  addSingleStatusUpdate,
} from "./features/orderStatusHistories/ordersStatusHistoriesSlice";
import { useDispatch } from "react-redux";
import ViewStaffDetails from "./pages/StaffManagement/ViewStaffDetails";
import StaffManagement from "./pages/StaffManagement/staff-management";
import { useIdleTimeout } from "./hooks/useIdleTimeout";
import LoginSaudi from "./pages/LoginSaudi/login-saudi";
import ForgotPasswordSaudi from "./pages/Forgot-password-saudi/ForgotPasswordSaudi";
import ChangePasswordSaudi from "./pages/ChangePasswordSaudi/ChangePasswordSaudi";

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data, isSuccess } = useProfileData();
  const socketRef = useRef<any>(null); // single socket instance
  const [socketConnected, setSocketConnected] = useState(false);
  const [unseenNotificationCount, setUnseenNotificationCount] = useState(0);

  const allHideHeaderRoutes = ["/", "/forgot-password", "/password-changed"];
  const hideHeader = allHideHeaderRoutes.includes(location.pathname);

  const LoginComponent =
    process.env.REACT_APP_EXTERNAL_ADMIN === "true" ? LoginSaudi : Login;
  const ForgotComponent =
    process.env.REACT_APP_EXTERNAL_ADMIN === "true"
      ? ForgotPasswordSaudi
      : ForgotPassword;
  const ChangePasswordComponent =
    process.env.REACT_APP_EXTERNAL_ADMIN === "true"
      ? ChangePasswordSaudi
      : ChangePassword;

  const isExternalAdmin = process.env.REACT_APP_EXTERNAL_ADMIN === "true";

  useEffect(() => {
    // Update title
    document.title = isExternalAdmin ? "Najiz Express" : "tracktechs";

    // Update favicon
    let link = document.querySelector(
      "link[rel*='icon']",
    ) as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      document.head.appendChild(link);
    }
    link.rel = "icon";
    link.href = isExternalAdmin ? "/logo/najizFavicon.png" : "/favicon.ico";
  }, [isExternalAdmin]);
  // 1 minute inactivity timeout for testing
  useIdleTimeout(30 * 60 * 1000);

  // Handle redirects after checking profile
  useEffect(() => {
    if (!isSuccess) return;

    if (!data || data === "Invalid or expired token") {
      // Not logged in
      if (!allHideHeaderRoutes.includes(location.pathname)) {
        navigate("/", { replace: true });
      }
    } else {
      // Logged in
      if (location.pathname === "/") {
        navigate("/orders", { replace: true });
      }
    }
  }, [data, isSuccess, location.pathname]);

  const isAuthenticated = data && data !== "Invalid or expired token";

  const user = data;

  // Socket setup (single instance)
  useEffect(() => {
    if (
      process.env.REACT_APP_Socket === "true" &&
      user?.id &&
      !socketRef.current
    ) {
      socketRef.current = initSocket();
      const socket = socketRef.current;

      console.log("🔌 Initializing socket:", socket);

      socket.on("connect", () => {
        console.log("✅ Socket Connected!", socket.id);
        setSocketConnected(true);
        socket.emit("setup", { id: user.id });
      });

      socket.on("disconnect", () => {
        console.log("❌ Socket Disconnected!");
        setSocketConnected(false);
      });

      socket.on("location received", (data: any) => {
        console.log("📍 Location received:", data);
      });

      socket.on("notification Received", (data: any) => {
        console.log("🔔 Notification received:", data);
        setUnseenNotificationCount(data?.unseenNotification || 0);
      });

      socket.on("new-order-status", (data: any) => {
        console.log("🔔 new-order-status:", data);
        dispatch(addSingleStatusUpdate(data));
        // toast.success(`New Status Of Order ${data?.awbNumber}`);
      });

      socket.on("new-order", (data: any) => {
        console.log("🔔 new-order:", data);
        dispatch(addNewOrder(data));
        // toast.success(`New Order ${data?.awbNumber}`);
      });

      return () => {
        socket.off("connect");
        socket.off("disconnect");
        socket.off("location received");
        socket.off("new-order-status");
        socket.off("notification Received");
      };
    }
  }, [user?.id]);

  // Emit new notifications
  useEffect(() => {
    if (user?.id && socketRef.current) {
      socketRef.current.emit("New Notification", user);
    }
  }, [user?.id, socketRef.current]);

  if (!isSuccess || data === undefined) {
    return <LoadingScreen />;
  }

  return (
    <div className="bg-gradient-to-tl from-20% to-[#E4E5E7] from-[#F9ECB7] h-screen overflow-hidden overflow-y-auto">
      {!hideHeader && <Header notification={unseenNotificationCount} />}
      <Toaster position="top-center" />

      <Routes>
        {isAuthenticated ? (
          <>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/orders" element={<OrderManagement />} />
            <Route
              path="/order-create-outlet"
              element={<OrderCreateOutlet />}
            />
            <Route path="/staff" element={<StaffManagement />} />
            <Route path="/staff/:id" element={<ViewStaffDetails />} />
            <Route path="/orders/:id" element={<ViewOrderDetails />} />
            <Route
              path="/shipment-details/:id"
              element={<ViewShipmentDetails />}
            />
            <Route path="/location" element={<Location />} />
            <Route path="/zone-management" element={<ZoneManagement />} />
            <Route path="/manifest" element={<PickupManagement />} />
            <Route
              path="/inventory-mangement"
              element={<InverntoryProduct />}
            />
            <Route path="/notifications" element={<Notification />} />
            <Route path="/add-item" element={<AddItem />} />
            <Route path="/add-item/:id" element={<AddItem />} />
            <Route path="/help-and-support" element={<HelpandSupport />} />
            <Route path="/invoice-management" element={<InvoiceManagement />} />
            {/* <Route path="/manifest" element={<ManifestManagement />} /> */}
            <Route path="/settings" element={<Settings />} />
            <Route path="/profile" element={<Profile />} />
            <Route
              path="/line-haul-management"
              element={<LineHaulManagement />}
            />
            {/* <Route path="/create-warehouse" element={<CreateWarehouse />} /> */}

            {/* fallback for unknown routes */}
            {/* <Route path="*" element={<Navigate to="/dashboard" replace />} /> */}
          </>
        ) : (
          <>
            <Route path="/" element={<LoginComponent />} />
            <Route path="/forgot-password" element={<ForgotComponent />} />
            <Route path="/password-changed" element={<ChangePasswordComponent />} />

            {/* fallback for unknown routes */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        )}
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
